import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const FSharp = () => {
  return (
    <StartInterviewLayout type="fsharp"/>
  )
}

export default FSharp;